export const controlTypes = { 'COUNTER': 1, 'STOPWATCH': 2, 'FREETEXT': 3, 'DATALIST': 4, 'SCANNER': 5, 'CAMERA': 6, 'EXTERNALAPI': 7}
export const ProjectFilterTypes = { 'CUSTOMER': 0, 'PROJECT_NAME': 1, 'LOCATION_NAME': 2, 'DESCRIPTION': 3}
export const dataListTypes = { 'NAME': 0 }
export const ExternalApiTypes = { 'NAME': 0 }
